<template>
  <div class="message-container">
    <div class="header">
      <div class="title">我的消息</div>
      <div class="actions">
        <el-radio-group v-model="filterStatus" size="small" @change="handleFilterChange">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="0">未读</el-radio-button>
          <el-radio-button :label="1">已读</el-radio-button>
        </el-radio-group>
        <el-button type="primary" size="small" @click="handleMarkAllAsRead">全部已读</el-button>
      </div>
    </div>
    <div class="content">
      <el-table
        ref="messageTable"
        :data="messageList"
        v-loading="loading"
        :highlight-current-row="true"
        stripe
        @row-click="handleRowClick"
      >
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="content" label="消息内容" min-width="300">
          <template slot-scope="scope">
            <div class="message-content" :class="{ 'unread': scope.row.isRead === 0 }">
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="bizType" label="业务类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="getBizTypeTag(scope.row.bizType)" size="small">
              {{ getBizTypeText(scope.row.bizType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="isRead" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isRead === 0 ? 'danger' : 'info'" size="small">
              {{ scope.row.isRead === 0 ? '未读' : '已读' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isRead === 0"
              type="text"
              size="small"
              @click.stop="handleMarkAsRead(scope.row)"
            >
              标记已读
            </el-button>
            <el-button
              type="text"
              size="small"
              @click.stop="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageList, markAsRead, markAllAsRead } from "@/api/message";

export default {
  data() {
    return {
      messageList: [],
      loading: false,
      total: 0,
      queryParams: {
        current: 1,
        size: 10,
        isRead: null
      },
      filterStatus: null
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const params = {
          current: this.queryParams.current,
          size: this.queryParams.size
        };
        if (this.queryParams.isRead !== null) {
          params.isRead = this.queryParams.isRead;
        }
        const res = await getMessageList(params);
        this.messageList = res.data.records;
        this.total = res.data.total;
      } catch (error) {
        this.$message.error("获取消息列表失败");
      } finally {
        this.loading = false;
      }
    },
    handleFilterChange(val) {
      this.queryParams.isRead = val;
      this.queryParams.current = 1;
      this.loadData();
    },
    handleSizeChange(val) {
      this.queryParams.size = val;
      this.queryParams.current = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.queryParams.current = val;
      this.loadData();
    },
    async handleMarkAsRead(row) {
      try {
        await markAsRead({ id: row.id });
        this.$message.success("标记成功");
        this.loadData();
      } catch (error) {
        this.$message.error("标记失败");
      }
    },
    async handleMarkAllAsRead() {
      try {
        await this.$confirm("确定要将所有消息标记为已读吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await markAllAsRead();
        this.$message.success("操作成功");
        this.loadData();
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("操作失败");
        }
      }
    },
    handleRowClick(row) {
      if (row.isRead === 0) {
        this.handleMarkAsRead(row);
      }
      this.handleViewDetail(row);
    },
    handleViewDetail(row) {
      this.jumpToBizPage(row);
    },
    jumpToBizPage(msg) {
      const userInfo = this.$store.state.system.userInfoweb;
      const userType = userInfo ? userInfo.type : null;
      if (msg.bizType === 1 || msg.bizType === 2 || msg.bizType === 3) {
        if (userType === 4) {
          this.$router.push({ path: "/workbench/trading", query: { highlightId: msg.bizId } });
        }
      } else if (msg.bizType === 4) {
        if (userType === 5) {
          this.$router.push({ path: "/financInstitutionPC/myProduct/lendingTransactions", query: { highlightId: msg.bizId } });
        }
      }
    },
    getBizTypeText(bizType) {
      const map = {
        1: "产品申请",
        2: "审核结果",
        3: "授信结果",
        4: "授信确认"
      };
      return map[bizType] || "未知";
    },
    getBizTypeTag(bizType) {
      const map = {
        1: "primary",
        2: "success",
        3: "warning",
        4: "info"
      };
      return map[bizType] || "info";
    },
    formatTime(timestamp) {
      if (!timestamp) return "-";
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.message-container {
  background: #fff;
  border-radius: 10px;
  padding: 20px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #303133;
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 15px;
    }
  }

  .content {
    .message-content {
      &.unread {
        font-weight: bold;
        color: #303133;
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
